import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { getDateInLocalTZ, toAbsCurrency, toCurrency } from '../../../Utils/util'
import { Flex, FlexColumn } from '../../Reusable/Container'
import { Text } from '../../Reusable/Text'
import { InitialCircle } from '../../Reusable/InitialCircle'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { ScrollableTableView } from './ScrollableTableView'
import FormattedIcon from './FormattedIcon'
import moment from 'moment'
import hexToRgba from 'hex-to-rgba'
import { Tooltip } from 'antd'
import { Divider } from '../../Reusable/Divider'
import StyledTooltip from '../../Reusable/StyledTooltip'

class CardSpendList extends Component {
    state = {
        spendByCard: this.props.cardSpendReport?.spendByCard
    }
    maxNameLen = 18

    columns = [
        {
            title: 'Name',
            dataIndex: 'card',
            key: 'name',
            render: (card, record, i) => (
                <Flex start centerHorizontally gap='8px'>
                    <InitialCircle name={card?.nickName} size={30} useFirstWordOnly={true} colorInd={i} />
                    <FlexColumn start gap='2px'>
                        <Text title={card?.nickName}>{card?.nickName?.length > this.maxNameLen ? `${card?.nickName.substr(0, this.maxNameLen)}..` : card?.nickName}</Text>
                        <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>{card?.last4}</Text>
                    </FlexColumn>
                </Flex>
            )
        },
        {
            title: 'Percent change',
            dataIndex: 'totalChangePercent',
            key: 'totalChangePercent',
            render: (totalChangePercent, record) => {
                var currMonth = moment()
                var prevMonth = moment().subtract(1, 'M')
                return (
                    <Flex start centerHorizontally gap='8px' className='cell-content'>
                        <FormattedIcon
                            icon={totalChangePercent >= 0 ? TrendingUp : TrendingDown}
                            size={25} 
                            title="Trend"
                        />
                        <Text>
                            <StyledTooltip
                                placement='right'
                                title={
                                    <FlexColumn style={{ padding: '8px' }} gap='4px'>
                                        <Text color={this.props.theme.body} weight={600} style={{ marginBottom: 5 }}>Month to date spend</Text>
                                        <Text color={this.props.theme.body}>
                                            {getDateInLocalTZ(currMonth, "MMMM")}: <span style={{ fontWeight: 600 }}>${toAbsCurrency(record.total)}</span>
                                        </Text>
                                        <Text color={this.props.theme.body}>
                                            {getDateInLocalTZ(prevMonth, "MMMM")}: <span style={{ fontWeight: 600 }}>${toAbsCurrency(record.previousPeriodTotal)}</span>
                                        </Text>
                                    </FlexColumn>
                                    
                                }
                                color={this.props.theme.colors.primary}
                            >
                                <span style={{ marginRight: 5, paddingBottom: 2, borderBottom: `1px solid ${this.props.theme.colors.primary}` }}>{Math.abs(Math.round(totalChangePercent))}%</span>
                            </StyledTooltip>
                            vs <span style={{  }}>{getDateInLocalTZ(prevMonth, "MMM")}</span>
                        </Text>
                    </Flex>
                )
            }
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            align: 'right',
            render: (total, record) => <span style={{ fontWeight: 600 }}>${toAbsCurrency(total)}</span>,
            width: '150px'
        }
    ]

    render() {
        const { spendByCard } = this.state

        return (
            <ScrollableTableView
                id="spendByCard"
                columns={this.columns}
                dataSource={spendByCard}
                rowKey='total'
                loading={false}
                borderView
                hideHeader
                scroll={{ y: 275 }} // Enable vertical scrolling
                pagination={false}
            />
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(CardSpendList)))